import { trackError } from '../utils/trackError';
import { TrackTMSPageDatalayer } from './types';

export const TMS_BOUNDARY = 'trackTMSPage';
export const TMS_DATA_MESSAGE =
  'page_name and env_template are required to track TMS page';
export const TMS_DATA_CONFIRMATION_MESSAGE =
  'transaction_id is required to track confirmation in TMS page';
export const handleTmsDataError = (data: TrackTMSPageDatalayer) => {
  if (!data?.page_name || !data?.env_template) {
    trackError(new Error(TMS_DATA_MESSAGE), TMS_BOUNDARY);
    return;
  }
  if (data?.page_name === 'confirmation' && !data?.transaction_id) {
    trackError(new Error(TMS_DATA_CONFIRMATION_MESSAGE), TMS_BOUNDARY);
    return;
  }
};
